import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  IconButton,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
} from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { user, users ,ownerdetail } from "../../../components/Apis";
import axiosInstance from "../../../axiosConfig/instance";
import axios from "axios";


// const Calendar = ({ startDate, endDate }) => {
//   const [currentDate, setCurrentDate] = useState(new Date(startDate));

//   const daysInMonth = new Date(
//     currentDate.getFullYear(),
//     currentDate.getMonth() + 1, 0).getDate();

//   const firstDayOfMonth = new Date(
//     currentDate.getFullYear(),
//     currentDate.getMonth(),
//     1
//   ).getDay();

//   const monthYear = currentDate.toLocaleString("default", {
//     month: "long",
//     year: "numeric",
//   });

//   const isDateInRange = (day) => {
//     const currentDay = new Date(
//       currentDate.getFullYear(),
//       currentDate.getMonth(),
//       day
//     );
//     const start = new Date(startDate);
//     const end = new Date(endDate);
//     return currentDay >= start && currentDay <= end;
//   };

//   const handlePrevMonth = () => {
//     setCurrentDate(new Date(currentDate.setMonth(currentDate.getMonth() - 1)));
//   };

//   const handleNextMonth = () => {
//     setCurrentDate(new Date(currentDate.setMonth(currentDate.getMonth() + 1)));
//   };

//   return (
//     <Paper elevation={3} sx={{ p: 3, maxWidth: 800, mx: "auto" }}>
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           mb: 3,
//         }}
//       >
//         <IconButton onClick={handlePrevMonth}>
//           <ArrowBackIcon />
//         </IconButton>
//         <Typography variant="h6" sx={{ fontWeight: "bold" }}>
//           {monthYear}
//         </Typography>
//         <IconButton onClick={handleNextMonth}>
//           <ArrowForwardIcon />
//         </IconButton>
//       </Box>

//       <Grid container spacing={1}>
//         {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
//           <Grid item xs={12 / 7} key={day}>
//             <Typography
//               color="text.secondary"
//               align="center"
//               sx={{
//                 fontSize: "0.875rem",
//                 fontWeight: "medium",
//                 mb: 1,
//               }}
//             >
//               {day}
//             </Typography>
//           </Grid>
//         ))}

//         {Array(firstDayOfMonth)
//           .fill(null)
//           .map((_, index) => (
//             <Grid item xs={12 / 7} key={`empty-${index}`}>
//               <Box sx={{ height: 40 }} />
//             </Grid>
//           ))}

//         {Array.from({ length: daysInMonth }, (_, i) => i + 1).map((day) => {
//           const isAvailable = isDateInRange(day);
//           return (
//             <Grid item xs={12 / 7} key={day}>
//               <Paper
//                 elevation={isAvailable ? 1 : 0}
//                 sx={{
//                   height: 40,
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   backgroundColor: isAvailable ? "primary.light" : "transparent",
//                   color: isAvailable
//                     ? "primary.contrastText"
//                     : "text.primary",
//                   cursor: isAvailable ? "pointer" : "default",
//                   transition: "all 0.2s",
//                   "&:hover": isAvailable
//                     ? {
//                       backgroundColor: "primary.main",
//                       transform: "scale(1.05)",
//                     }
//                     : {},
//                 }}
//               >
//                 <Typography variant="body2">{day}</Typography>
//               </Paper>
//             </Grid>
//           );
//         })}
//       </Grid>
//     </Paper>
//   );
// };

//




const Sidebaravailability = ({ unit }) => {
  console.log("mndasm,dasjddjashj", unit);

  const [selectedSection, setSelectedSection] = useState(null);
  const formatTime = (timeString) => {
    const [hours, minutes] = timeString.split(":");
    const suffix = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
    return `${formattedHours}:${minutes} ${suffix}`;
  };
  const [checkIn, setCheckIn] = useState(formatTime(unit.check_in || "06:00:00"));
  const [checkOut, setCheckOut] = useState(formatTime(unit.check_out || "11:00:00"));

  function formatDateRange(startDate, endDate) {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const options = { day: "numeric", month: "short" };
    const startFormatted = start.toLocaleDateString("en-GB", options);
    const endFormatted = end.toLocaleDateString("en-GB", options);
    return `${startFormatted} - ${endFormatted}`;
  }

  const CheckInCheckOut = ({
    checkIn,
    checkOut,
    onCheckInChange,
    onCheckOutChange,
  }) => {
    const times = [
      "6:00 AM",
      "7:00 AM",
      "8:00 AM",
      "9:00 AM",
      "10:00 AM",
      "11:00 AM",
      "12:00 PM",
      "1:00 PM",
      "2:00 PM",
    ];

    return (
      <Paper elevation={3} sx={{ p: 3, maxWidth: 800, mx: "auto" }}>
        <Typography variant="h6" sx={{ mb: 2 }}>
          Check-in & Check-out Times
        </Typography>

        {/* Dropdown for Check-in */}
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel>Check-in</InputLabel>
          <Select
            value={checkIn}
            label="Check-in"
            onChange={onCheckInChange}  // ✅ استخدام الدالة الممررة لضبط القيمة
          >
            {times.map((time) => (
              <MenuItem key={time} value={time}>
                {time}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Dropdown for Check-out */}
        <FormControl fullWidth>
          <InputLabel>Check-out</InputLabel>
          <Select
            value={checkOut}
            label="Check-out"
            onChange={onCheckOutChange}  // ✅ استخدام الدالة الممررة لضبط القيمة
          >
            {times.map((time) => (
              <MenuItem key={time} value={time}>
                {time}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Paper>
    );
  };

  // Calender Functions
  const Calendar = ({ startDate, endDate, reservedDates }) => {
    const [currentDate, setCurrentDate] = useState(new Date(startDate));
    const [selectedDate, setSelectedDate] = useState(null);

    const daysInMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() + 1,
      0
    ).getDate();

    const firstDayOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1
    ).getDay();

    const monthYear = currentDate.toLocaleString("default", {
      month: "long",
      year: "numeric",
    });

    const isDateInRange = (day) => {
      const currentDay = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        day
      );
      const start = new Date(startDate);
      const end = new Date(endDate);
      return currentDay >= start && currentDay <= end;
    };

    // Convert reserved dates to a Set for fast lookup
    const reservedSet = new Set(reservedDates);

    const isReserved = (day) => {
      const formattedDate = `${String(day).padStart(2, "0")}-${String(
        currentDate.getMonth() + 1
      ).padStart(2, "0")}-${currentDate.getFullYear()}`;
      return reservedSet.has(formattedDate);
    };

    const handlePrevMonth = () => {
      setCurrentDate(new Date(currentDate.setMonth(currentDate.getMonth() - 1)));
    };

    const handleNextMonth = () => {
      setCurrentDate(new Date(currentDate.setMonth(currentDate.getMonth() + 1)));
    };

    const handleDayClick = (day) => {
      const formattedDate = `${String(day).padStart(2, "0")}-${String(
        currentDate.getMonth() + 1
      ).padStart(2, "0")}-${currentDate.getFullYear()}`;

      if (reservedSet.has(formattedDate)) {
        setSelectedDate(formattedDate); // Show details for reserved dates
      } else {
        setSelectedDate(null); // Close the details when clicking on an unreserved date
      }
    };


    return (
      <div>
        <Paper elevation={3} sx={{ p: 3, maxWidth: 800, mx: "auto" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 3,
            }}
          >
            <IconButton onClick={handlePrevMonth}>
              <ArrowBackIcon />
            </IconButton>
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              {monthYear}
            </Typography>
            <IconButton onClick={handleNextMonth}>
              <ArrowForwardIcon />
            </IconButton>
          </Box>

          <Grid container spacing={1}>
            {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
              <Grid item xs={12 / 7} key={day}>
                <Typography
                  color="text.secondary"
                  align="center"
                  sx={{
                    fontSize: "0.875rem",
                    fontWeight: "medium",
                    mb: 1,
                  }}
                >
                  {day}
                </Typography>
              </Grid>
            ))}

            {Array(firstDayOfMonth)
              .fill(null)
              .map((_, index) => (
                <Grid item xs={12 / 7} key={`empty-${index}`}>
                  <Box sx={{ height: 40 }} />
                </Grid>
              ))}

            {Array.from({ length: daysInMonth }, (_, i) => i + 1).map((day) => {
              const isAvailable = isDateInRange(day);
              const reserved = isReserved(day);

              return (
                <Grid item xs={12 / 7} key={day}>
                  <Paper
                    elevation={reserved || isAvailable ? 1 : 0}
                    onClick={() => handleDayClick(day)}
                    sx={{
                      height: 40,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: reserved
                        ? "#2196F3" // Blue for reserved dates
                        : isAvailable
                          ? "white" // White for available dates
                          : "transparent",
                      color: reserved ? "white" : "black",
                      cursor: reserved ? "pointer" : "default",
                      transition: "all 0.2s",
                      "&:hover": reserved
                        ? {
                          backgroundColor: "#1976D2", // Darker blue on hover
                          transform: "scale(1.05)",
                        }
                        : isAvailable
                          ? {
                            backgroundColor: "#f0f0f0",
                            transform: "scale(1.05)",
                          }
                          : {},
                    }}
                  >
                    <Typography variant="body2">{day}</Typography>
                  </Paper>
                </Grid>
              );
            })}
          </Grid>
        </Paper>

        {/* Show the div when a reserved date is clicked */}
        {selectedDate && (
          <Box
            sx={{
              mt: 3,
              p: 2,
              borderRadius: 2,
              backgroundColor: "#f8f9fa",
              maxWidth: 400,
              mx: "auto",
              textAlign: "center",
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
            }}
          >
            <Typography variant="h6" sx={{ mb: 1 }}>
              Reserved Date Selected
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              {selectedDate}
            </Typography>

            <Typography variant="body1" sx={{ mb: 2 }}>
              OWNER NAME : {unit.owner_name}
            </Typography>
            <Button
              variant="contained"
              color="primary"
              onClick={() => setSelectedDate(null)}
            >
              Close
            </Button>
          </Box>
        )}
      </div>
    );
  };
  // Calender Functions

  return (
    <Box sx={{ display: "flex", height: "100vh", overflowY: "auto", }}>
      {/* sideBar in availability */}
      <Box
        sx={{
          width: "30%",
          borderRight: "1px solid #ddd",
          overflow: "hidden",
          p: 2,
          backgroundColor: "#ffffff",
        }}
      >
        <Typography variant="h6" sx={{ mb: 2 }}>
          Unit Overview
        </Typography>
        <Paper
          elevation={3}
          onClick={() => setSelectedSection("check")}
          sx={{
            p: 2,
            borderRadius: 2,
            border: "1px solid #ddd",
            backgroundColor: "white",
            maxWidth: 400,
            cursor: "pointer",

            mb: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Box>
                <Typography variant="body2" color="text.secondary">
                  Check-in
                </Typography>
                <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                  {formatTime(unit.check_in)}
                </Typography>
              </Box>
            </Box>

            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Box>
                <Typography variant="body2" color="text.secondary">
                  Check-Out
                </Typography>
                <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                  {formatTime(unit.check_out)}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Paper>
        <Paper
          onClick={() => setSelectedSection("Calendar")}
          elevation={3}
          sx={{
            mb: 2,
            p: 2,
            borderRadius: 2,
            border: "1px solid #ddd",
            backgroundColor: "white",
            cursor: "pointer",
            maxWidth: 400,
          }}
        >
          <Typography variant="h6" sx={{ mb: 1, fontWeight: "bold" }}>
            Date
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {formatDateRange(unit.available_from, unit.available_to)}
          </Typography>
        </Paper>
        <Paper
          elevation={3}
          sx={{
            maxWidth: 400,
            mb: 2,
            p: 2,
            borderRadius: 2,
            border: "1px solid #ddd",
            backgroundColor: "white",
          }}
        >
          <Typography variant="h6" sx={{ mb: 1, fontWeight: "bold" }}>
            Price
          </Typography>
          <Typography
            variant="h6"
            sx={{ mb: 1, fontWeight: "bold", textAlign: "center" }}
          >
            {unit.price} EGP
          </Typography>
          <Typography variant="body2" color="text.secondary" align="right">
            Per night
          </Typography>
        </Paper>
        <Paper
          elevation={3}
          sx={{
            maxWidth: 400,
            mb: 2,
            p: 2,
            borderRadius: 2,
            border: "1px solid #ddd",
            backgroundColor: "white",
          }}
        >
          <Typography variant="h6" sx={{ mb: 1, fontWeight: "bold" }}>
            Discount
          </Typography>
          <Typography variant="body2" color="text.secondary">
            10% Monthly discount
          </Typography>
        </Paper>
      </Box>

      {/* main content of sideBar of Availability */}
      <Box
        sx={{ flexGrow: 1, overflow: "hidden", p: 2, backgroundColor: "#fff" }}
      >
        {selectedSection === "Calendar" && (
          //Calender  
          <>
            <Calendar
              startDate={unit.available_from}
              endDate={unit.available_to}
              reservedDates={unit.reserved_dates}
            />
            {/* <div>
              Muhamed Ahmed Fouda
            </div> */}
          </>
        )}
        {selectedSection === "check" && (
          <CheckInCheckOut
            checkIn={checkIn}
            checkOut={checkOut}
            onCheckInChange={(e) => setCheckIn(e.target.value)}  // تمرير دالة لضبط القيمة
            onCheckOutChange={(e) => setCheckOut(e.target.value)}  // تمرير دالة لضبط القيمة
          />
        )}
      </Box>
    </Box>
  );
};

export default Sidebaravailability;
